import type { QueryClient } from '@tanstack/react-query';
import type { RealtimeEvent } from '@/context/RealtimeContext';
import { leagueQueryKeys } from './queryKeys';

export const leagueSyncEvent = (workspaceId: string, event: RealtimeEvent): number | null => {
  const resource = event.payload as { domain?: string; season?: number } | undefined;
  if (event.workspace_id !== workspaceId || event.type !== 'league.synchronized' || resource?.domain !== 'league' || !Number.isSafeInteger(resource.season) || Number(resource.season) <= 0) return null;
  return Number(resource.season);
};

export const invalidateLeagueSeason = (client: QueryClient, workspaceId: string, season: number): Promise<void> => client.invalidateQueries({
  queryKey: leagueQueryKeys.root(workspaceId),
  predicate: query => {
    const key = query.queryKey;
    if (key[0] !== 'v2' || key[1] !== 'league' || key[2] !== workspaceId) return false;
    if (key[3] === 'seasons') return true;
    if (key[3] === 'match-any-season' || key[3] === 'match-players-any-season') return true;
    return key[3] === 'season' && key[4] === season;
  },
});
